export const formatPoint = (value: number): string => {
  if (!value) {
    return 0 + 'P';
  }
  return `${value.toLocaleString()}P`;
};

export const getDayWithSuffix = (day: number): string => {
  if (day >= 11 && day <= 13) return `${day}th`;

  const lastDigit = day % 10;
  switch (lastDigit) {
    case 1:
    case 21:
    case 31:
      return `${day}st`;
    case 2:
    case 22:
      return `${day}nd`;
    case 3:
    case 23:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
};
